<div class="flex h-full w-full flex-col justify-start">
  <div class="image-container flex h-full w-full flex-col justify-end">
    <app-product-label
      *ngIf="!openCartSteps"
      [product]="product"
      [highestDiscount]="product.highestDiscount"
      [smallLabels]="smallLabels"
    ></app-product-label>
    <span class="variantTag" *ngIf="product.hasVariant">Varias opciones</span>
    <img [src]="product.pictureUrl" [ngClass]="{ hiddenImg: hover && product.pictureSecondaryUrl }" />
    <img *ngIf="product.pictureSecondaryUrl" [src]="product.pictureSecondaryUrl" [ngClass]="{ hiddenImg: !hover }" />

    <div
      *ngIf="addedToCartConfirmation"
      @fadeAnimation
      class="added-confirmation flex w-full flex-row items-center justify-between"
    >
      <div class="flex flex-row items-center gap-2.5">
        <ion-icon src="../../../../assets/icon/circle-check.svg"></ion-icon>
        <span>Añadido al carrito con éxito</span>
      </div>
      <span>{{ this.price.amt * this.qty | currency }}</span>
    </div>
  </div>
  <div *ngIf="!openCartSteps" class="product-info flex flex-col items-start">
    <span class="title-message">{{ product.title }}</span>
    <ion-button fill="clear" class="view-details">Ver más detalles</ion-button>
  </div>
  <div class="show-ellipsis">
    <span class="sub-message"> </span>
  </div>
</div>
